import Vue from 'vue'
import VueRouter from 'vue-router'
import Default from '@/pages/default'

Vue.use(VueRouter)

export default new VueRouter({
  base: process.env.VUE_BASE_URL,
  mode: 'history',
  routes: [
    {
      path: '/search',
      name: 'default-view',
      component: Default
    },
    {
      path: '/search/:searchValue',
      name: 'default-view',
      component: Default
    }
  ]
})
